import { render, staticRenderFns } from "./Technical.vue?vue&type=template&id=9706dabc&scoped=true&"
import script from "./Technical.vue?vue&type=script&lang=js&"
export * from "./Technical.vue?vue&type=script&lang=js&"
import style0 from "./Technical.vue?vue&type=style&index=0&id=9706dabc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9706dabc",
  null
  
)

export default component.exports